const UserIcon = ({ color = '#9CA3AF' }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="8" r="4" stroke={color} strokeWidth="1.6"/>
    <path d="M4 21c0-4.418 3.582-7 8-7s8 2.582 8 7" stroke={color} strokeWidth="1.6" strokeLinecap="round"/>
  </svg>
)

export default UserIcon
